import Vue from 'vue';
import Router from 'vue-router';
import { getGlobalHandle } from '@getaccept/lib-shared/src/helpers';
import { routes } from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: getGlobalHandle()._basePath || process.env.NODE_ENV === 'development' ? '/login/' : '/',
  routes,
});

router.beforeEach((to, _from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} | GetAccept`;
    return next();
  }

  document.title = `GetAccept`;
  next();
});

export default router;
